/**
 * ehr#710 - User Titles: how many users hold a title, and the delete prompt that warns when
 * some do. A user's title is saved as text on the user, so deleting or renaming a title in
 * this list never changes anyone's profile; they keep the old text until it's changed there.
 */

/** Users (active or not) whose saved title is this label. */
export const titleUsers = (label: string, users: { title: string | null }[]) =>
  users.filter((u) => (u.title ?? '').trim().toLowerCase() === label.trim().toLowerCase()).length;

/** The confirm text for deleting a title held by `n` users. */
export function titleDeletePrompt(label: string, n: number): string {
  if (!n) return `Delete the title “${label}”?`;
  return `Delete the title “${label}”?\n\n${n} user${n === 1 ? '' : 's'} ${
    n === 1 ? 'has' : 'have'
  } this title. ${n === 1 ? 'They keep' : 'They all keep'} “${label}” on their profile; it just won’t be offered for new picks.`;
}
